/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface PicklistInterface {
  name: string;
  label: string;
  description: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Picklist implements PicklistInterface {
  name: string;
  label: string;
  description: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: PicklistInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Picklist`.
   */
  public static getModelName() {
    return "Picklist";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Picklist for dynamic purposes.
  **/
  public static factory(data: PicklistInterface): Picklist{
    return new Picklist(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Picklist',
      plural: 'picklists',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Picklist.ts